<template lang="pug">
  section.section-color.section-param(id="registration" class="d-flex justify-center")
    v-container.container-ra.mx-auto(fluid)
      v-card.card-ra.elevation-0
        template(v-if="isSmallWidth")
          p.text-title-ra Поможем сформировать команду
          p.subtext-ra Оставьте заявку и мы свяжемся с вами </br> в ближайшее время
        registrationCard.registration-style(:booking="specialistTeam")
        p.subtext-ra.text-down(
          v-if="isSmallWidth"
          ) Вы также можете отдать реализацию Вашего проекта целиком нам. </br> Приходите на сайт нашего проектного направления -&nbsp;
          a.link-ra(@click="openBLSSoft()") www.bls-soft.ru
          a.link-ra-xxs(@click="openBLSSoft()") </br> www.bls-soft.ru
      v-card.card-info.d-flex.elevation-0(v-if="!isSmallWidth")
        v-card.info-ra.elevation-0
          p.text-title-ra Поможем сформировать команду
          p.subtext-ra Оставьте заявку, и мы свяжемся с вами </br> в ближайшее время
          v-img.img-style(src="@/assets/application.svg" contain)
          p.subtext-ra Вы также можете отдать реализацию Вашего проекта </br> целиком нам. Приходите на сайт нашего проектного </br>направления -&nbsp;
            a.link-ra(@click="openBLSSoft()") www.bls-soft.ru

</template>

<script>
import registrationCard from './ui/RegistrationCard'

export default {
  name: "RegistrationApplicationSection",
  components: {
    registrationCard
  },
  props: {
    specialistTeam: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      isSmallWidth: false,
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    openBLSSoft() {
      window.open('https://bls-soft.ru/', '_blank')
    },
    onResize () {
      this.isSmallWidth =  (window.innerWidth <= 1500)
    }
  }
}
</script>

<style scoped lang="sass">
  @import "ui/scss/variables.scss"
  @import "ui/scss/colors.scss"

  @media (max-width: 361px)
    .link-ra-xxs
      text-decoration: none
      color: $black

    .link-ra
      display: none

  @media (min-width: 362px)
    .link-ra-xxs
      display: none

  @media (max-width: $xsOnly)
    .text-title-ra
      margin-top: 40px !important

  @media(max-width: 750px)
    .card-ra
      margin-left: $marginMax !important
      margin-right: $marginMax !important

  @media(min-width: $smOnlyStart) and (max-width: $smOnlyEnd)
    .subtext-ra
      padding: 0 8%

  @media(max-width: 1500px)
    .card-ra
      margin-left: auto
      margin-right: auto

    .registration-style
      margin-left: auto
      margin-right: auto

    .subtext-ra
      line-height: 120%
      font-size: max(calc(5px + 1.3vw), 16px)
      margin-bottom: 30px

    .text-title-ra
      margin-top: 68px
      font-size: max(calc(10px + 1.4vw), 24px)
      line-height: 120%
      margin-bottom: 10px

  @media(min-width: 1501px)
    .text-title-ra
      font-size: min(calc(12px + 1.5vw), 40px)
      line-height: 120%
      margin-bottom: 21px

    .card-ra
      margin-top: 3%
      margin-left: $marginLeftContent
      margin-right: $marginRightContent

    .registration-style
      margin-left: auto

    .subtext-ra
      line-height: 120%
      font-size: min(calc(6px + 1vw), 24px)
      margin-bottom: 0

  @media(min-width: 1501px) and (max-width: 1700px)
    .card-info
      margin-top: calc(-915px + 6%) !important
      max-width: calc(50% - (40px + 4%)) !important

  @media(min-width: $xxl)
    .container-ra
      max-width: $maxWidthContainer
      margin: auto

  .card-info
    position: absolute
    z-index: 1
    display: flex
    margin-top: -915px
    background: transparent
    max-width: 1700px

  .container-ra
    background-image: url("~@/assets/fourSlide.png")
    background-size: auto auto
    background-position: center
    justify-content: start
    background-color: $backgroundContainer

  .img-style
    margin-bottom: 39px

  .info-ra
    background: transparent
    justify-self: center
    align-self: end
    margin-left: 2%

  .card-ra
    background: transparent
    max-width: 1400px

  .text-title-ra
    text-align: center
    color: $black
    font-family: GothamProMedium

  .link-ra
    text-decoration: none
    color: $black

  .subtext-ra
    text-align: center
    color: $greyText
    font-family: GothamProClassic

  .text-down
    margin-right: auto
    margin-left: auto
    min-width: 280px
    max-width: 500px
    margin-top: 40px

</style>

